"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EventStreamMarshaller_1 = require("./EventStreamMarshaller");
/** browser event stream serde utils provider */


exports.eventStreamSerdeProvider = function (options) {
  return new EventStreamMarshaller_1.EventStreamMarshaller(options);
};